import reduxApi from 'redux-api';
import customFetch from 'api/axios';
import { API_URL } from 'constants/config';

export default reduxApi({
  getNamThanhTra: {
    url: `${API_URL}/namThanhTras`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHienThiKeHoachThanhTra: {
    url: `${API_URL}/keHoachThanhTras/isHienThiKeHoachThanhTra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  deleteTaiLieuVanThuMulti: {
    url: `${API_URL}/taiLieuVanThus/multi`,
    options: (url, params, getState) => {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  postTaiLieuVanThuMulti: {
    url: `${API_URL}/taiLieuVanThus/multi`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  updateTaiLieuVanThuMulti: {
    url: `${API_URL}/taiLieuVanThus/multi`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  getHinhThucKeHoachThanhTra: {
    url: `${API_URL}/chucNangKeHoachThanhTra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThucHienPhapLuatVeTT: {
    url: `${API_URL}/thucHienPhapLuatVeThanhTra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHinhThucThanhTraChuyenNganh: {
    url: `${API_URL}/hinhThucThanhTraChuyenNganhs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getChucNangCuocThanhTra: {
    url: `${API_URL}/chucNangCuocThanhTras`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getKeHoachThanhTra: {
    url: `${API_URL}/keHoachThanhTras`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getKeHoachThanhTraOld: {
    url: `${API_URL}/keHoachThanhTraOld`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getKeHoachThanhTraDetail: {
    url: `${API_URL}/keHoachThanhTras/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLinhVucThanhTra: {
    url: `${API_URL}/linhVucThanhTras`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViChuTri: {
    url: `${API_URL}/coQuanQuanLys/donViChuTris/cuocThanhTra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViKHTT: {
    url: `${API_URL}/coQuanQuanLys/donViKeHoachThanhTra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getKiemTraDoiTuongTT: {
    url: `${API_URL}/cuocThanhTras/validateTrungDoiTuongThanhTra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanhSachDoiTuongDaDeXuatXuLy: {
    url: `${API_URL}/danhSachDoiTuongDaDeXuatXuLy`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getNhomDoiTuongThanhTras: {
    url: `${API_URL}/nhomDoiTuongThanhTras`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  nhomHinhThucCuocThanhTraPhanLoai: {
    url: `${API_URL}/hinhThucCuocThanhTraPhanLoai`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCanCuThanhTraLai: {
    url: `${API_URL}/canCuThanhTraLais`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTienDoThanhTra: {
    url: `${API_URL}/tienDoThanhTras`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuanDieuTra: {
    url: `${API_URL}/coQuanQuanLys/coQuanDieuTras/cuocThanhTra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuanDieuTraThanhTra: {
    url: `${API_URL}/coQuanDieuTraThanhTra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getChiTietDoiTuongTraThanhTra: {
    url: `${API_URL}/doiTuongViPhams/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHinhThucKienNghi: {
    url: `${API_URL}/hinhThucKienNghi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViBanHanh: {
    url: `${API_URL}/donViBanHanhs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getListDonViBanHanh: {
    url: `${API_URL}/coQuanQuanLy/get-list`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiHinhThanhTra: {
    url: `${API_URL}/loaiHinhThanhTras`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDoiTuongThanhTra: {
    url: `${API_URL}/doiTuongThanhTras`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCuocThanhTra: {
    url: `${API_URL}/cuocThanhTras`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCuocThanhTraTheoDoi: {
    url: `${API_URL}/cuocThanhTraTheoDois`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getChiTietCuocThanhTra: {
    url: `${API_URL}/cuocThanhTras/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getChiTietLienQuanCuocThanhTra: {
    url: `${API_URL}/cuocThanhTras/:id/infos`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getVaiTroThanhVienDoan: {
    url: `${API_URL}/vaiTroThanhVienDoans`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThoiHanThanhTra: {
    url: `${API_URL}/cuocThanhTras/thoiHanThanhTra`,
    options: (url, params, getState) => {
      return {
        method: 'GET',
        params: params
      };
    }
  },
  getHinhThucThanhTra: {
    url: `${API_URL}/hinhThucCuocThanhTra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDoiTuongViPham: {
    url: `${API_URL}/doiTuongViPhams`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postCuocThanhTra: {
    url: `${API_URL}/cuocThanhTras`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params,
        params: {
          loaiCuoc: params.loaiCuoc
        }
      };
    }
  },
  patchCuocThanhTra: {
    url: `${API_URL}/cuocThanhTras/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params,
        params: {
          loaiCuoc: params.loaiCuoc
        }
      };
    }
  },
  deleteKeHoachThanhTra: {
    url: `${API_URL}/keHoachThanhTras/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteCuocThanhTraHuy: {
    url: `${API_URL}/cuocThanhTras/:id/huy`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  },
  postTaiLieuVanThuMulti: {
    url: `${API_URL}/taiLieuVanThus/multi`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  resetBuocGiaiQuyet: {
    url: `${API_URL}/taiLieuVanThus/resetBuocGiaiQuyet`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE',
        params: _params
      };
    }
  },
  deleteCuocThanhTraKHTT: {
    url: `${API_URL}/keHoachThanhTras/:id/cuocThanhTras`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  },
  deleteCuocThanhTra: {
    url: `${API_URL}/cuocThanhTras/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteDoiTuongViPham: {
    url: `${API_URL}/doiTuongViPhams/multi`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  },
  postKeHoachThanhTra: {
    url: `${API_URL}/keHoachThanhTras`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  getValidateKeHoachThanhTra: {
    url: `${API_URL}/keHoachThanhTras/checkExistsData`,
    options: (url, params, getState) => {
      return {
        method: 'GET',
        data: params
      };
    }
  },
  postDoiTuongViPham: {
    url: `${API_URL}/doiTuongViPhams/multi`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateDoiTuongViPham: {
    url: `${API_URL}/doiTuongViPhams/multi`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateKeHoachThanhTra: {
    url: `${API_URL}/keHoachThanhTras/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getCuocThanhTraTrung: {
    url: `${API_URL}/cuocThanhTraTrungs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  ketQuaTheoDoiSaiPham: {
    url: `${API_URL}/ketQuaTheoDoiSaiPham`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  ketQuaChuyenCoQuanDieuTra: {
    url: `${API_URL}/ketQuaChuyenCoQuanDieuTra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  ketQuaThucHienDonDoc: {
    url: `${API_URL}/ketQuaThucHienDonDoc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  hinhThucDonDocs: {
    url: `${API_URL}/hinhThucDonDocs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  donDocDoiTuongs: {
    url: `${API_URL}/donDocDoiTuongs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  ketLuanVeNoiDungKiemTra: {
    url: `${API_URL}/ketLuanVeNoiDungKiemTra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postDonDoc: {
    url: `${API_URL}/donDocDoiTuongs/multi`,
    options: (url, _params, getState) => {
      return {
        method: 'POST',
        data: _params
      };
    }
  },
  patchDonDoc: {
    url: `${API_URL}/donDocDoiTuongs/multi`,
    options: (url, _params, getState) => {
      return {
        method: 'PATCH',
        data: _params
      };
    }
  },
  deleteDonDoc: {
    url: `${API_URL}/donDocDoiTuong/multi`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  },
  getDSCuocThanhTraTrung: {
    url: `${API_URL}/cuocThanhTraTrungs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLichSuXuLyCTTTrung: {
    url: `${API_URL}/lichSuXuLyCTTTrungs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLichSuXuLyCTTTrungChiTiet: {
    url: `${API_URL}/lichSuXuLyCTTTrungs/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postDonViDeXuat: {
    url: `${API_URL}/lichSuXuLyCTTTrungs/donViHeThongDeXuat`,
    options: (url, _data, getState) => {
      return {
        method: 'POST',
        data: _data.params
      };
    }
  },
  postXuLyTTT: {
    url: `${API_URL}/XuLyCTTTrungs/xu-ly`,
    options: (url, _params, getState) => {
      return {
        method: 'POST',
        data: _params
      };
    }
  },
  patchXuLyTTT: {
    url: `${API_URL}/XuLyCTTTrungs/xu-ly/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getTrangThaiXuLyTTT: {
    url: `${API_URL}/trangThaiXuLyCuocThanhTraTrungs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getlichSuXuLyCTTTrungCurrent: {
    url: `${API_URL}/lichSuXuLyCTTTrungCurrent`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTrangThaoXuLyTrungTaiDV: {
    url: `${API_URL}/trangThaiXuLyTrungCuaDonVis`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTrangThaiThanhTraRutGon: {
    url: `${API_URL}/trangThaiThanhTraRutGons`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLichSuXuLyCTTTrungCu: {
    url: `${API_URL}/lichSuXuLyCTTTrungCu`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCuocThanhTraTrungXuLy: {
    url: `${API_URL}/cuocThanhTraTrungs/xuly`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getKHTTDonVi: {
    url: `${API_URL}/capCoQuanQuanLys/timKiemKeHoachVaCuoc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  xuatExcelXuLyTrung: {
    url: `${API_URL}/lichSuXuLyCTTTrungs/donViHeThongDeXuat`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  patchCauHinhKeHoachThanhTra: {
    url: `${API_URL}/cauHinhKeHoachThanhTra/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getCauHinhKeHoachThanhTra: {
    url: `${API_URL}/cauHinhKeHoachThanhTra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDsQuanLyHoSo: {
    url: `${API_URL}/ho-so-thanh-tra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCheckTrungMaDoanhNghiep: {
    url: `${API_URL}/doi-tuong-thanh-tra/double-check`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  approveDoiTuongThanhTra: {
    url: `${API_URL}/doi-tuong-thanh-tra/approve`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getDsLinhVucThanhTra: {
    url: `${API_URL}/linh-vuc-thanh-tra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDsLoaiDoiTuong: {
    url: `${API_URL}/loaiDoiTuongThanhTras`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
}).use('fetch', customFetch);


// WEBPACK FOOTER //
// ./src/api/thanhtra.js